import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { superAdminService } from '../services/super-admin.service';
import type { CreateSuperAdminRequest, SuperAdmin } from '../types/super-admin.types';
import { SUPER_ADMINS_QUERY_KEY } from './useSuperAdmins';

export function useCreateSuperAdmin(): {
  createSuperAdmin: UseMutateFunction<SuperAdmin, Error, CreateSuperAdminRequest>;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: Error | null;
  reset: () => void;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (request: CreateSuperAdminRequest) => superAdminService.createSuperAdmin(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SUPER_ADMINS_QUERY_KEY });
    },
  });

  return {
    createSuperAdmin: mutation.mutate,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
